import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { DatePipe } from '@angular/common';
declare var app;
@Component({
  selector: 'app-a2-edite',
  templateUrl: './a2-edite.component.html',
  styleUrls: ['./a2-edite.component.scss']
})
export class A2EditeComponent extends GridBaseCase{
  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  submitArr = [];
  submitObj = {};
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) {super();  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    console.log(that.element);
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // let seaobj={};
    // seaobj["v_FK_SystemUser_ID"]=that.com.GetAccount.Id;
    // seaobj["v_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore")["ID"];
    // body.RequestBody = JSON.stringify(seaobj);
    // if (!that.com.GetAccount.IsAdmin) {
    //   // console.log(that.month);
    //   if (!that.searchDate) {
    //     let startDate = that.com.getNow + " 00:00:00";
    //     let endDate = that.com.getNow + " 23:59:59";
    //     that.searchDate = that.com.BetweenDate(startDate, endDate);
    //   }
    //   // if (that.searchDate) {
    //   //   body.RequestBody = JSON.stringify({ "v_CreateTime": that.searchDate });
    //   // }
    // }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.field) {
              objfield[element.field] = item[element.field];
            }
          });
        //  that.onInput(objfield);
          that.dataArrayList.push(objfield);
        });
         console.log(that.dataArrayList);
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }

  submit() {
    if (this.submitArr.length == 0) {
      this.msg.Alert("无数据提交");
      return;
    }
    let that = this;
    let ele = null;
    //TODO:提交参数动态
    // if(that.template.content.element[1]){
    //   ele = that.template.content.element[1];
    //   
    // }




    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "add";
    body.ConfigType = "form";
    // body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    this.submitArr.forEach(function(subitem){
          console.log(subitem);
          if(subitem["ID"])
          {
            body.OpType="edite";
          }
    });
     console.log(that.submitArr);
    body.RequestBody = JSON.stringify(that.submitArr);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.msg.Alert('提交成功！');
         //按钮添加权限
        //  console.log("按钮添加权限");
         let out = that.com.GetStorageKey("btn");
         if(out){
           that.com.setBadge(out.pagename,out.temp,out.name);
         }
        let datepie: DatePipe = new DatePipe("en-US");
        let datetime = datepie.transform(new Date(), "yyyyMMddHHmmss") + "&ok";//上班打卡时间
        // that.router.navigate(["tabs/contact/HomeSFA/add/" + datetime]);
        that.com.Go("tabs/contact/HomeSFA/add/" + datetime);
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
    })
  }

  onInput(item) {
    let that = this;
    // let arraybolean: boolean = false;
    // const tbstore=that.com.GetStorageKey("tbstore").ID;
    // let datepie: DatePipe = new DatePipe("en-US");
    // let datetime = datepie.transform(new Date(), "yyyy-MM-dd HH:mm:ss");//上班打卡时间
    // if (item['num'].value != null) {
    //   if (this.submitArr.length == 0) {
    //     let obj = {};
    //     obj['a_FK_TBStore_ID'] = tbstore;
    //     obj['a_FK_TBDayDataManager_id'] = item['ID'].value;
    //     obj['a_ProductNumber'] = item['num'].value;
    //     obj["a_DayDate"] = datetime;
    //     obj["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
    //     obj["a_FK_TBProductBrand_ID"]=item['TBProductBrand_ID'].value;
    //     obj["a_FK_TBMinimumSaleableUnit_ID"]=item['TBMinimumSaleableUnit_ID'].value;
    //     if(item["v_ID"].value)
    //     obj["ID"]=item["v_ID"].value;
    //     that.submitArr.push(obj);
    //   } else {
    //     this.submitArr.forEach(function (ele, index) {
    //       if (ele['a_FK_TBDayDataManager_id'] == item['ID'].value) {
    //         arraybolean = true;
    //         ele['a_ProductNumber'] = item['num'].value;
    //       }
    //     });
    //     if (!arraybolean) {
    //       let obj = {};
    //       obj['a_FK_TBStore_ID'] = tbstore;
    //       obj['a_FK_TBDayDataManager_id'] = item['ID'].value;
    //       obj['a_ProductNumber'] = item['num'].value;
    //       obj["a_DayDate"] = datetime;
    //       obj["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
    //       obj["a_FK_TBProductBrand_ID"]=item['TBProductBrand_ID'].value;
    //       obj["a_FK_TBMinimumSaleableUnit_ID"]=item['TBMinimumSaleableUnit_ID'].value;
    //       if(item["v_ID"].value)
    //       obj["ID"]=item["v_ID"].value;
    //       that.submitArr.push(obj);
    //     }
    //   }
    // }
    console.log(item);
  }

}
